export enum VerificationType {
    Phone = "phone",
    Email = "email",
    Login = "login",
}
